"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.font = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var measure_unit_1 = require("./measure-unit");
exports.font = type_guard_1.object({
    props: {
        size: measure_unit_1.measureUnit,
        family: type_guard_1.string(),
        style: type_guard_1.optional(type_guard_1.defaulted(type_guard_1.enums(['normal', 'italic', 'oblique']), 'normal')),
        weight: type_guard_1.optional(type_guard_1.defaulted(type_guard_1.enums([100, 200, 300, 400, 500, 600, 700, 800, 900]), 400)),
        align: type_guard_1.optional(type_guard_1.enums(['left', 'right', 'center'])),
        lineHeight: type_guard_1.optional(measure_unit_1.measureUnit),
        letterSpacing: type_guard_1.optional(measure_unit_1.measureUnit),
        transform: type_guard_1.optional(type_guard_1.enums(['none', 'capitalize', 'uppercase', 'lowercase', 'full-width'])),
        decoration: type_guard_1.optional(type_guard_1.enums(['underline', 'line-through']))
    }
});
